interface PrimaryIconProps {
  color: string;
  width?: string;
  height?: string;
}

export const PrimaryIcon = ({color, width, height}: PrimaryIconProps) => {
  return (
    <svg width={width ?? 12} height={height ?? 20} viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.563975 0.863281C0.603038 0.375 1.00929 0 1.49757 0H9.62257C10.1109 0 10.5171 0.375 10.5562 0.863281L11.0991 7.75391C11.3296 10.668 9.27882 13.1992 6.49757 13.6719V18.125H8.99757C9.5171 18.125 9.93507 18.543 9.93507 19.0625C9.93507 19.582 9.5171 20 8.99757 20H5.56007H2.12257C1.60304 20 1.18507 19.582 1.18507 19.0625C1.18507 18.543 1.60304 18.125 2.12257 18.125H4.62257V13.6719C1.84132 13.1992 -0.209462 10.668 0.0171001 7.75391L0.563975 0.863281ZM5.56007 11.875C7.70851 11.875 9.39991 10.043 9.23194 7.90234L9.14991 6.875H1.97023L1.88819 7.90234C1.72023 10.043 3.41163 11.875 5.56007 11.875ZM2.11866 5H9.00148L8.75538 1.875H2.36476L2.11866 5Z" fill={color ?? "#4B5851"}/>
    </svg>
  )
}
